import { faStar } from "@fortawesome/free-solid-svg-icons";
import male from "../../assets/images/male.png";
import Icon from "../Icon";
import { Link } from "react-router-dom";
const ReviewCard = ({ data }) => {
  return (
    <Link to={`/guide-details/${ data.id }`} style={styles.card}>
      <img
        src={data.file?.Url}
        alt="Profile"
        style={styles.image}
      />

      <div style={styles.content}>
        <div style={styles.header}>
        <>
          <h2 className="custom-text-color" style={styles.name}>{data.name}</h2>
        </>
          <div className="d-flex align-items-center">
            <span>
              {
                Array(5).fill(0).map(( _, i )=>
                  <Icon icon={faStar} className={"fs-8 " + (i+1 <= data.rating ? "text-warning" : "text-secondary")} />
                )
              }
              </span>
            <p className="mb-0 bold fs-8 ms-2">{ data.rating }/5 {data.reviewsCount}</p>
          </div>
        </div>

        <p className="custom-text-color" style={styles.description}>{data.about} </p>

        <div style={styles.footer}>
          <button style={styles.button}>Book</button>
          <span style={styles.price}>₹ {data.pricePerHour}/hour</span>
        </div>
      </div>
    </Link>
  );
};

export default ReviewCard
const styles = {
  card: {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    width: "700px",

    // margin: "auto",
  },
  image: {
    width: "150px",
    height: "150px",
    borderRadius: "8px",
    objectFit: "cover",
    marginRight: "16px",
  },
  content: {
    flex: 1,
  },
  header: {
    marginBottom: "8px",
  },
  name: {
    margin: "0",
    fontSize: "20px",
    fontWeight: "bold",
  },
  reviews: {
    color: "#999",
  },
  description: {
    margin: "8px 0",
    fontSize: "14px",
    height: "45px",
    overflow: "hidden"
  },
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
  },
  button: {
    backgroundColor: "#ff6600",
    color: "#fff",
    border: "none",
    borderRadius: "25px",
    padding: "8px 35px",
    cursor: "pointer",
    fontSize: "14px",
    marginRight: "20px",
  },
  price: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#e74c3c",
  },
};